/**
 * @desc 海关要素-新增
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(body: defs.basics.CustomsInfoRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/customsInfo/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
